import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

const th = { padding: 14, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 14, fontSize: 13 }
const btn = { padding: '6px 14px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }

export default function ActivityApprovals() {
  const [pending, setPending] = useState([])
  const [approved, setApproved] = useState([])
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState('pending')

  useEffect(() => { loadApprovals() }, [])

  const loadApprovals = () => {
    fetch(`${API}/base-activities/cms/pending`).then(r => r.json())
      .then(d => { if (d.success) { const items = d.data || []; setPending(items.filter(a => a.status === 'pending')); setApproved(items.filter(a => a.status === 'approved')) } })
      .catch(() => {
        setPending([{ id: 1, baseName: '北京朝阳活动基地', title: '消防员体验日', date: '2026-04-22', price: 298, submittedAt: '2026-04-16' }, { id: 2, baseName: '上海浦东活动基地', title: '小小医生职业体验', date: '2026-04-28', price: 358, submittedAt: '2026-04-17' }])
        setApproved([{ id: 3, baseName: '广州天河活动基地', title: 'AI动画创作一日营', date: '2026-04-20', price: 598, approvedAt: '2026-04-15' }])
      }).finally(() => setLoading(false))
  }

  const handleApprove = async (id) => { 
    if (!confirm('确定通过此活动审核？')) return
    try { 
      const res = await fetch(`${API}/partner-store/activities/${id}/approve`, { method: 'POST' }); 
      const data = await res.json(); 
      if (data.success) { alert('审核通过'); loadApprovals() } 
      else { alert(data.error || '操作失败') }
    } catch (e) { alert('操作失败') } 
  }
  
  const handleReject = async (id) => { 
    if (!confirm('确定拒绝此活动？')) return; 
    try { 
      const res = await fetch(`${API}/partner-store/activities/${id}/reject`, { method: 'POST' }); 
      const data = await res.json(); 
      if (data.success) { alert('已拒绝'); loadApprovals() } 
      else { alert(data.error || '操作失败') }
    } catch (e) { alert('操作失败') } 
  }

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>
  const list = tab === 'pending' ? pending : approved

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🏕️ 活动审核</h2>
      <div style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
        {[{ key: 'pending', label: '待审批', count: pending.length, bg: '#1890ff' }, { key: 'approved', label: '已通过', count: approved.length, bg: '#52c41a' }].map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{ padding: '10px 20px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14, background: tab === t.key ? t.bg : '#f5f5f5', color: tab === t.key ? '#fff' : '#666' }}>
            {t.label}（{t.count}）
          </button>
        ))}
      </div>
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        {list.length === 0 ? (
          <div style={{ padding: 60, textAlign: 'center', color: '#999' }}>暂无{tab === 'pending' ? '待审批' : '已通过'}活动</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ background: '#fafafa' }}>{['活动名称', '基地', '日期', '价格', tab === 'pending' ? '提交时间' : '审核时间', '操作'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
            <tbody>
              {list.map(a => (
                <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}>{a.title}</td>
                  <td style={td}>{a.baseName || a.institution_name || '-'}</td>
                  <td style={td}>{a.date || a.activity_date || '-'}</td>
                  <td style={{ ...td, color: '#f5222d' }}>¥{a.price || 0}</td>
                  <td style={td}>{tab === 'pending' ? (a.submittedAt || a.created_at || '-') : (a.approvedAt || a.updated_at || '-')}</td>
                  <td style={td}>
                    {tab === 'pending' ? (
                      <><button onClick={() => handleApprove(a.id)} style={{ ...btn, background: '#f6ffed', color: '#52c41a', border: '1px solid #b7eb8f' }}>通过</button><button onClick={() => handleReject(a.id)} style={{ ...btn, background: '#fff1f0', color: '#ff4d4f', border: '1px solid #ffccc7', marginLeft: 8 }}>拒绝</button></>
                    ) : (
                      <span style={{ color: '#52c41a', fontSize: 12 }}>✓ 已通过</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}